import nextjsLogo from '../../assets/logos/nextjs.svg'

interface NextjsLogoProps {
  className?: string
  /** False when the mark sits on a surface that stays light in dark mode. */
  invertOnDark?: boolean
}

/**
 * The Next.js brand mark.
 *
 * Static for the same reason as ReactLogo: it is a trademark, not an illustration.
 *
 * This one does need inverting in dark mode, where ReactLogo does not. The mark is a
 * black disc with a white N, so on the navy dark surface it reads as a hole punched in
 * the card. A plain `invert` turns it into a white disc with a black N, which is the
 * official inverse of this logo rather than a distortion of it.
 *
 * Deliberately NOT the `brightness-0 contrast-200 invert` chain the Lottie icons use.
 * That chain exists to flatten a multi-colour animation to a single silhouette, and
 * applied here it would fill the N in and leave a plain white circle.
 */
const NextjsLogo = ({ className = 'w-14 h-14', invertOnDark = true }: NextjsLogoProps) => (
  <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
    <img
      src={nextjsLogo}
      alt=""
      aria-hidden="true"
      className={`w-full h-full object-contain ${invertOnDark ? 'dark:invert' : ''}`}
    />
  </div>
)

export default NextjsLogo
